export class NffReportExclusionPnPostModel {
  public Pn?: string;
  public Customer?: string;
  public FleetType?: string;
}

export class NffReportExclusionPnPutModel {
  public Id?: number;
  public Pn?: string;
  public Customer?: string;
  public FleetType?: string;
}
